<template>
  <div class="sign-up-page">
    <div class="emoji">👋</div>
    <div class="title">שמחים שחזרת! מספר הטלפון שלך כבר קיים אצלנו במערכת</div>
    <div class="explain">כנראה שנרשמת בעבר לשירות בעזרת אותו מספר טלפון. <span class="explain-bold">מיד נשלח לך לינק
ל-WhatsApp להמשך ההרשמה.</span>
    </div>
    <support-footer />
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '../../Segment';

export default {
  name: 'MemberAlreadyExistsError',
  components: {
    SupportFooter: BaseUI.SupportFooter,
  },
  async created() {
    Segment.trackUserGot('MemberAlreadyExistsError', { phoneNumber: this.phoneNumber });
  },
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .sign-up-page {
    @include responsive-padding;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .emoji {
      margin-top: 50px;
      font-size: 76px;
    }

    .title {
      @include white-page-frame-title;
      margin-top: 30px;
      margin-bottom: 20px;
      line-height: 30px;
    }

    .explain {
      max-width: 300px;
      font-size: 16px;
      line-height: 24px;
      white-space: pre-wrap;

      .explain-bold {
        font-weight: bold;
      }
    }

    .support-footer {
      margin-top: 100px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/general-errors/MemberAlreadyExistsError.vue